import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import * as React from 'react';
import { IContentBox } from '../Interfaces/IContentBox';

const useContentStyles = makeStyles({
  root: {
    padding: '0px 10px 0px 10px',
  },
  box: {
    backgroundColor: 'white',
    padding: '30px',
    boxShadow: '2px 2px 0 rgba(0,0,0,.1)',
    borderLeft: '1px solid #e0e0e0',
    borderTop: '1px solid #e0e0e0',
  },
});

const ContentBox = (props: IContentBox) => {
  const classes = useContentStyles();
  return (
    <div className={classes.root}>
      <Typography variant="h1">{props.title}</Typography>
      <div className={classes.box}>{props.children}</div>
    </div>
  );
};

export default ContentBox;
